<template>
	<span>{{ address }}</span>
</template>
<script>
	export default {
		props: ['place'],
		computed: {
			address() {
				if(!this.place) return '';

				let address = this.place.formatted_address;
				let formattedAddress = '';

				// build the address from the first 3 parts of the string
				address.split(',').forEach((a, index) => {
					if(index < 3) {
						formattedAddress += `${a}, `;
					}
				});

				// trim whitespace and remove comma from end of string
				return formattedAddress.trim().replace(/,$/, '');
			}
		}
	}
</script>
